<div class="rounded-md shadow-sm p-4 flex flex-col items-center text-center h-full">
  @let descriptionValue = description();
  @let compatibilityValue = compatibility();

  @switch (icon()) {
    @case ('desktop') {
      <svg
        mib-desktop-icon
        class="h-12"
        [class.text-success]="compatibilityValue"
        [class.text-error]="compatibilityValue === false"
        [class.text-gray-500]="compatibilityValue === undefined"></svg>
    }
    @case ('browser') {
      <svg
        mib-world-icon
        class="h-12"
        [class.text-success]="compatibilityValue"
        [class.text-error]="compatibilityValue === false"
        [class.text-gray-500]="compatibilityValue === undefined"></svg>
    }
    @case ('video') {
      <svg
        mib-video-icon
        class="h-12"
        [class.text-success]="compatibilityValue"
        [class.text-error]="compatibilityValue === false"
        [class.text-gray-500]="compatibilityValue === undefined"></svg>
    }
  }

  <h5 class="mt-3 text-xl">{{ label() }}</h5>
  @switch (compatibility()) {
    @case (true) {
      <p class="compatible">Compatible</p>
    }
    @case (false) {
      <p class="not-compatible">Not compatible</p>
    }
    @default {
      <mib-spinner [overlay]="true"></mib-spinner>
      <p>…</p>
    }
  }

  @if (descriptionValue) {
    <small>{{ descriptionValue }}</small>
  }
</div>
